import React, { useMemo } from "react";
import { createAvatar } from "@dicebear/core";
import { lorelei } from "@dicebear/collection";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

export default function GeneratedAvatar({ seed, name, className }) {
  const src = useMemo(() => createAvatar(lorelei, {
    backgroundColor: ["b6e3f4", "c0aede", "d1f4d9", "ffd5dc", "ffdfbf"],
    backgroundType: ["gradientLinear"],
    radius: 50,
    seed: [String(seed || name || "shop")],
  }).toDataUri(), [name, seed]);

  const initials = String(name || "Shop")
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

  return (
    <Avatar className={cn("h-9 w-9", className)}>
      <AvatarImage src={src} alt="" />
      <AvatarFallback className="bg-[#0E5B52] text-xs text-white">{initials}</AvatarFallback>
    </Avatar>
  );
}
